import { Card, CardContent } from '@/components/ui/card'
import { QrCode, CheckCircle, Clock, TrendingUp, Download, FileText, CalendarDays, CalendarRange, CalendarCheck } from 'lucide-react'
import type { LibroStats } from '../types'

interface StatsCardsProps {
  stats: LibroStats
}

export function StatsCards({ stats }: StatsCardsProps) {
  const resumenCards = [
    { title: 'Total Códigos', value: stats.total_codigos, icon: QrCode },
    { title: 'Disponibles', value: stats.codigos_disponibles, icon: Clock },
    { title: 'Canjeados', value: stats.codigos_canjeados, icon: CheckCircle },
    { title: 'Solicitudes', value: stats.total_solicitudes, icon: FileText },
    { title: 'Total Actividad', value: stats.total_descargas + stats.total_solicitudes, icon: TrendingUp },
  ]

  const descargasCards = [
    { title: 'Total Descargas', value: stats.total_descargas, icon: Download },
    { title: 'Hoy', value: stats.descargas_hoy ?? 0, icon: CalendarDays },
    { title: 'Esta Semana', value: stats.descargas_semana ?? 0, icon: CalendarRange },
    { title: 'Este Mes', value: stats.descargas_mes ?? 0, icon: CalendarCheck },
  ]

  const tasaCanje = stats.tasa_canje ?? 0

  return (
    <div className="space-y-4">
      {/* Resumen General */}
      <div className="grid gap-4 grid-cols-2 sm:grid-cols-5">
        {resumenCards.map((card) => (
          <Card
            key={card.title}
            className="border border-gray-300 dark:border-gray-700 bg-gradient-to-r from-teal-500/15 via-teal-500/5 via-50% to-transparent dark:from-teal-800/20 dark:via-teal-900/10 dark:via-50% dark:to-transparent"
          >
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <card.icon className="h-4 w-4 text-teal-500" />
                <div>
                  <p className="text-xs text-muted-foreground">{card.title}</p>
                  <p className="text-lg font-bold text-black dark:text-white">{card.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Progreso de Canjes */}
      <Card className="border border-gray-300 dark:border-gray-700">
        <CardContent className="p-4">
          <div className="flex justify-between text-xs mb-1">
            <span className="text-muted-foreground">Progreso de Canjes</span>
            <span className="font-semibold text-black dark:text-white">{tasaCanje.toFixed(1)}%</span>
          </div>
          <div className="h-2 w-full rounded-full bg-teal-500/10">
            <div
              className="h-2 rounded-full transition-all"
              style={{ background: 'linear-gradient(90deg, #14b8a6, #0f766e)', width: `${tasaCanje}%` }}
            />
          </div>
        </CardContent>
      </Card>

      {/* Estadísticas de Descargas */}
      <div className="grid gap-4 grid-cols-2 sm:grid-cols-4">
        {descargasCards.map((card) => (
          <Card
            key={card.title}
            className="border border-gray-300 dark:border-gray-700 bg-gradient-to-r from-teal-500/15 via-teal-500/5 via-50% to-transparent dark:from-teal-800/20 dark:via-teal-900/10 dark:via-50% dark:to-transparent"
          >
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <card.icon className="h-4 w-4 text-teal-500" />
                <div>
                  <p className="text-xs text-muted-foreground">{card.title}</p>
                  <p className="text-lg font-bold text-black dark:text-white">{card.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}
